import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hostRatePipe'
})
export class HostRatePipe implements PipeTransform {

  transform(hostList,hostRate,test) {

    
    
    if(!hostList || !hostRate){
      return hostList
    }
    

    
    
    return hostList.filter(employee=>{
       return employee.average_rate >= hostRate;
    });;
  }

}
